export const breakpoints = [768, 1024, 1440]
